import React from "react";
import {InputText} from "primereact/inputtext";
import {makeStyles} from '@material-ui/core/styles';
import {Dialog} from "primereact/dialog";
import Button from '@material-ui/core/Button';
import SubtitleLabel from "../../app/Title/SubtitleLabel/SubtitleLabelView";
import PropTypes from "prop-types";

const useStyles = makeStyles(theme => ({
    button: {
        margin: theme.spacing(1),
    },
    input: {
        display: 'none',
    },
}));

const PresvalUploadFileView = (props) => {
    const classes = useStyles();
    return (
        <React.Fragment>
            {props.uploadMessagesGrowl}
            {props.buttonOpen}

            <Dialog visible={props.displayDialog} header={props.dialogHeader} modal={true}
                    onHide={props.onHideDialog} closable={false}
                    contentStyle={{overflow:"visible"}}
                    style={{width: "45%", textAlign: 'left',}}>

                <div className="p-grid p-fluid">
                    {props.bodyUploadFile ? props.bodyUploadFile : ""}
                    <div className="p-col-12" style={{padding: '.5em'}}>
                        <SubtitleLabel header="Seleccione un archivo*" isBold={true}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '.8em', align: 'middle'}}>
                        <InputText disabled={true} value={props.fileName}/>
                    </div>
                    <div className="p-col-12 p-md-6 p-lg-6" style={{padding: '0em'}}>
                        <input
                            accept="text/csv/*"
                            className={classes.input}
                            id="contained-button-file"
                            type="file"
                            onChange={props.onUpload}/>
                        <label htmlFor="contained-button-file">
                            <Button variant="contained"
                                    component="span"
                                    className={classes.button}>
                                <i className="material-icons">folder_open</i>
                            </Button>
                        </label>
                    </div>
                </div>
            </Dialog>

            <Dialog visible={props.displayDialogPreview} header={props.dialogPreviewHeader} modal={true}
                    closable={false} onHide={props.onHideDialog}
                    style={{width: "45%", textAlign: 'left',}}>
                <iframe id="filePreview" title="Preview"/>
            </Dialog>

            <Dialog visible={props.visibleUploadResDialog} header={props.headerUploadResDialog}
                    modal={true} closable={false} onHide={props.onHideResDialog}
                    footer={props.footerUploadResDialog}>
                <div style={{padding: "1em"}}>
                    {props.uploadResTemplate}
                </div>
            </Dialog>
        </React.Fragment>
    )
};
PresvalUploadFileView.propTypes = {
    uploadMessagesGrowl: PropTypes.element.isRequired,
    buttonOpen: PropTypes.element.isRequired,
    displayDialog: PropTypes.bool.isRequired,
    dialogHeader: PropTypes.element.isRequired,
    onHideDialog: PropTypes.func.isRequired,
    bodyUploadFile: PropTypes.element,
    fileName: PropTypes.string.isRequired,
    onUpload: PropTypes.func.isRequired,
    displayDialogPreview: PropTypes.bool.isRequired,
    dialogPreviewHeader: PropTypes.element.isRequired,
}

export default PresvalUploadFileView;
